<template>
  <div class="min-h-screen flex sm:block flex-col justify-center items-center overflow-hidden mx-auto bg-won-bg-blue">
    <Anouncement
        v-if="announcements.length"
        :key="announcements.length"
        class="h-[50px] w-full"
        @closed="handleCloseAnnouncement"
        :announcements="announcements"
    />

    <div class="container sm:mx-auto sm:py-12 sm:px-6">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import Anouncement from '../components/anouncement'
import { getAnnouncements } from '../api/announcements'

const announcements = ref([])
const closedAnnouncements = localStorage.getItem('closedAnnouncements') 
    ? JSON.parse(localStorage.getItem('closedAnnouncements'))
    : []

const handleCloseAnnouncement = (uuid) => {
  announcements.value = announcements.value.filter(el => uuid !== el.uuid)
}

onMounted(() => {
  getAnnouncements()
    .then((data) => {
      announcements.value = data.filter(el => !closedAnnouncements.includes(el.uuid))
    })
})
</script>
